<template>
  <div>
    <p class="text-center text-2xl"><strong>用户隐私政策</strong></p>
    <p class="mt-2 text-center">更新及生效日期：2022年4月25日</p>
    <p class="mt-2">
      欢迎您使用北京欧心医联医疗科技有限公司提供的产品和服务！我们深知个人信息对您的重要性，我们一向承诺使用我们产品和服务的用户个人信息及隐私安全。为了您能更好地使用我们的产品和服务，我们会收集您的个人相关信息。我们希望通过本《用户隐私政策》（以下简称"隐私政策"）向您说明在您接受我们的产品服务时，我们如何收集、使用、储存这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。
    </p>
    <p class="font-bold">
      本政策适用于北京欧心医联医疗科技有限公司提供的产品或服务，包括网站、客户端及未设独立隐私政策的关联公司网站及或登录相关客户端。如我们及关联公司的产品或服务中使用了我们提供的产品或服务但未设立独立隐私政策的，则本政策同样适用于该部分产品或服务、我们及关联公司就其向您提供的产品或服务单独设立有隐私权政策的，则相应产品或服务适用相应隐私权政策。
    </p>
    <p class="mt-2">
      为了更好地为您提供服务，在您开始使“EMHUB”及相关服务之前，请您务必认真阅读并充分理解隐私政策，一旦您使用或在我们更新本隐私政策后继续使用我们的产品或服务，即意味着您同意本《用户隐私政策》，如果您不同意本隐私政策内容，将导致我们无法为您提供完整的服务。
    </p>
    <p class="mt-5"><strong>一、定义</strong></p>
    <p class="mt-2">
      当您使用我们的任何产品和服务时，本隐私政策即适用，无论该产品和服务是否单独设置了隐私条款还是注册登录用户。请您注意，以下信息不适用本隐私政策：
    </p>
    <p class="mt-2">1.1 个人信息</p>
    <p class="mt-2">指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
    <p class="mt-2">如姓名、出生日期、身份证件号码、通信通讯联系方式、通信记录和内容、账号密码、财产信息、行踪轨迹、健康生理信息等。</p>
    <p class="mt-2">1.2 个人敏感信息</p>
    <p class="mt-2">包括身份证件号码、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。</p>
    <p class="mt-2">1.3 个人信息删除</p>
    <p class="mt-2">指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
    <p class="mt-2">1.4 业务数据</p>
    <p class="mt-2">不同于个人信息，是指EMHUB的用户利用EMHUB的服务上传、下载、分发等通过EMHUB的技术服务处理的数据。</p>
    <p class="mt-2">1.5 医疗信息服务推送功能</p>
    <p class="mt-2">
      如我们需要收集、储存和使用您的个人信息，将严格遵守《个人信息保护法》等相关法律法规的要求，合法收集、储存和使用。
    </p>
    <p class="mt-5"><strong>二、我们收集的信息</strong></p>
    <p class="mt-2">
      我们提供产品或服务时，可能会收集、储存和使用下列与您有关的个人信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
    </p>
    <p class="mt-2">1.	您提供的信息，您在注册、登录EMHUB账号时向我们提供的手机号码、密码等。</p>
    <p class="mt-2">2.	您通过EMHUB向其他方提供的共享个人信息，以及您使用服务时所存储的个人信息。</p>
    <p class="mt-2">
      3.	我们将会依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律法规规定的前提下，使用从第三方获得的您的个人信息。
    </p>
    <p class="mt-2">
      4.	当您使用EMHUB的以下功能时，我们需要您提供相应的权限许可：
    </p>
    <p class="mt-2">1)	我们会收集您的设备地址、唯一设备标识码，用于识别您为EMHUB用户。</p>
    <p class="mt-2">
      2)	为保障产品正常运行，以及系统版本更新和维护的相关问题锁定，设备会获取用户软件安装列表信息以及储存权限，我们将按照法律法规规定，采用安全保护措施，保护您的个人信息及隐私安全。
    </p>
    <p class="mt-2">
      3)	为了能上传用户头像，我们将申请获取您的相机、相册权限，已经录音权限，使用第三方sdk 包含相关权限。
    </p>
    <p class="mt-2">
      4)	为了能支持缓存头像，我们将申请获取您的文件读写权限。
    </p>
    <p class="mt-2">
      5)	为您推送文章、视频、病例、通知等消息，我们可能使用定向推送功能。
    </p>
    <p class="mt-2">
      5.	为保障您正常使用我们的服务，为向您提供更契合您需求的页面展示和搜索结果，了解产品适配性，维护我们服务的正常运行，改善及优化您的服务体验，我们可能会收集您的设备型号、系统版本、网络类型、唯一设备标识符、APP崩溃记录、流量统计、操作日志等信息。
    </p>
    <p class="mt-2">
      另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：
    </p>
    <p class="mt-2">
      1)	与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的。
    </p>
    <p class="mt-2">2)	与犯罪侦查、起诉、审判和判决执行等直接相关的。</p>
    <p class="mt-2">3)	出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到用户同意的。</p>
    <p class="mt-2">4)	所收集的用户信息是您自行向社会公众公开的。</p>
    <p class="mt-2">5)	从合法公开披露的信息中收集用户信息的，如合法的新闻报道、政府信息公开等渠道。</p>
    <p class="mt-2">6)	根据您要求签订和履行合同所必需的。</p>
    <p class="mt-2">
      7)	用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。
    </p>
    <p class="mt-2">
      8)	为开展合法的新闻报道所必需的。
    </p>
    <p class="mt-2">
      9)	出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的用户信息进行去标识化处理的。
    </p>
    <p class="mt-2">10)	法律法规规定的其他情形。</p>
    <p class="mt-2">
      请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。
    </p>
    <p class="mt-2">6.	EMHUB涉及用户信息使用的SDK相关情况，列举如下：</p>
    <p class="mt-2">
      1)	为了保证网络请求连接正常，我们会经过您的同意获取网络权限，使用第三方okhttp3，retrofit等SDK获取IP。
    </p>
    <p class="mt-5"><strong>三、信息的存储</strong></p>
    <p class="mt-2">1.	信息存储的地点我们依照法律法规的规定，将在境内运营过程中收集和产生您的个人信息存储于中华人民共和国境内。目前我们不会跨境传输或存储您的个人信息。</p>
    <p class="mt-2">
      2.	信息存储期限我们会根据法律法规规定,在EMHUB为您提供服务期限内保留您的个人信息,并通过安全的方式进行存储。当我们的产品或服务发生停止运营的情形时,我们将以推送通知、公告等形式通知您,并在合理的期限内删除您的用户信息或进行匿名化处理。
    </p>
    <p class="mt-5"><strong>四、信息安全</strong></p>
    <p class="mt-2">
      我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL）、匿名化处理等手段来保护您的用户信息。我们通过不断提升的技术手段加强安装在您设备端的软件的安全能力，以防止您的用户信息泄露。例如，我们为了安全传输会在您设备本地完成部分信息加密的工作；为了预防病毒、木马程序或其他恶意程序、网站会了解您设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生用户信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。
    </p>
    <p class="mt-5"><strong>五、信息使用方式</strong></p>
    <p class="mt-2">
      我们可能将通过某些功能所收集的信息用于我们的其他服务。包括但不限于精准营销、对您阅读过的内容进行信息安全类提示、基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容等。为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的任何个人身份信息相结合。我们不会使用来自“通讯录”、“照片”或能访问用户数据的其他 API 的信息来构建您的联系人数据库，以供自己使用或对外提供/分发给第三方，也不会收集关于您设备上安装的其他App，以用于分析或投放广告/市场营销等其他商业目的。同时我们也不会通过“通讯录”或“照片”收集的信息来联系您。如我们使用您的用户信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的用户信息前，再次向您告知并通过页面提示、交互流程、网站公告等方式征得您的明确同意或授权。
    </p>
    <p class="mt-5"><strong>六、信息的对外提供</strong></p>
    <p class="mt-2">
      目前，我们不会主动共享或对外提供您的用户信息至第三方，如存在其他共享或对外提供您的用户信息或您需要我们将您的用户信息共享或对外提供至第三方情形时，我们会通过页面提示、交互流程、网站公告等方式直接或确认第三方征得您的明确同意或授权。我们不会对外公开披露其收集的用户信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并通过页面提示、交互流程、网站公告等方式征得您的明确同意或授权。另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、对外提供、公开披露用户信息无需事先征得用户信息主体的授权同意：
    </p>
    <p class="mt-2">1）与国家安全、国防安全直接相关的；</p>
    <p class="mt-2">2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p class="mt-2">3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
    <p class="mt-2">4）出于维护用户信息主体或其他个人的生命、财产等重大合法权益但又很难得到用户同意的；</p>
    <p class="mt-2">5）用户信息主体自行向社会公众公开的用户信息；</p>
    <p class="mt-2">6）从合法公开披露的信息中收集用户信息的，如合法的新闻报道、政府信息公开等渠道。</p>
    <p class="mt-5"><strong>七、用户权利</strong></p>
    <p class="mt-2">在您使用产品服务期间，为了让您更便捷地查询访问、更正您的个人信息，同时保障您撤回个人信息时使用的统一和注销账号的全系，我们在产品设计中为您提供了相应的操作设置。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。</p>
    <p class="mt-2">1.	查询个人信息进入EMHUB后，点击“我的“ -> ”头像“ -> ”个人中心“</p>
    <p class="mt-2">2.	更正个人信息进入EMHUB后，点击“我的“ -> ”头像“ -> ”个人中心“</p>
    <p class="mt-2">3.	撤销授权撤回相机、文件读写授权访问授权iOS系统-设置-选择EMHUB，关闭相关授权Android系统-设置-应用管理-EMHUB-权限管理，关闭相关授权，或者进入EMHUB后，点击“我的” -> “系统设置”->“账号与安全”-> “权限设置” -> “前往系统权限设置”</p>
    <p class="mt-2">4.	注销账户进入EMHUB后，点击“我的” -> “系统设置”-> “账户与安全” -> “账号注销”，根据对应的操作说明，方能注销账号。一旦注销账号，则用户无法继续使用相应的产品、服务。</p>
    <p class="mt-2">5.	消息中心，点击我的--系统设置--消息开关按钮可以打开或者关闭消息，为了更好的服务，我们默认开启消息按钮，用户若不需要可以前往关闭。</p>
    <p class="mt-2">6.	个性化推荐，点击我的--系统设置--个性化推荐按钮可以打开或者关闭个性化推荐，为了更好的服务，我们默认开启个性化推荐按钮，用户若不需要可以前往关闭。</p>
    <p class="mt-5"><strong>八、如何联系我们</strong></p>
    <p class="mt-5">北京欧心医联医疗科技有限公司</p>
    <p class="mt-2">+86 （10）8529 6181</p>
    <p class="mt-2">Info@emhub.com.cn</p>
    <p class="mt-2">（注册地/常用办公地址：北京市朝阳区嘉里中心北塔405）</p>
    <p></p>
  </div>
</template>

<script>
export default {
  name: "secretAgree"
}
</script>

<style scoped>

</style>